import { render, staticRenderFns } from "./view_vendor.vue?vue&type=template&id=770d8112&scoped=true"
import script from "./view_vendor.vue?vue&type=script&lang=js"
export * from "./view_vendor.vue?vue&type=script&lang=js"
import style0 from "./view_vendor.vue?vue&type=style&index=0&id=770d8112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770d8112",
  null
  
)

export default component.exports